import { render } from "./index.vue?vue&type=template&id=ea6198f6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ea6198f6&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea6198f6"],['__file',"src/views/widget/shop/tiktok/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea6198f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea6198f6', __exports__)) {
    console.log('reload')
    api.reload('ea6198f6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=ea6198f6&scoped=true", () => {
    console.log('re-render')
    api.rerender('ea6198f6', render)
  })

}


export default __exports__